import React from 'react';
import withAppState from '../mobx/withAppState';

import MenuCard from './MenuCard';
import spinach from '../assets/img/slices/slice3.svg';
import tomato from '../assets/img/slices/slice4.svg';
import hand from '../assets/img/slices/slice-and-hand.svg';
import burst from '../assets/img/slices/burst.svg';
import star from '../assets/img/slices/star.svg';


const categoryPreferredName = (name) => {
    var preferredName = "";
    if(name === "Pizzeria") {
        preferredName = "Pizza";
    } else {
        preferredName = name;
    }
    return preferredName.toUpperCase();
  }

const renderMenuItems = props => {
    const { data, dietaryFilter, filterDiet } = props;

    return data
        .filter(item => {
            if (!filterDiet) return true;
            for (let key in dietaryFilter) {
                if (dietaryFilter[key] === true) {
                    if (item.dietaryAndAllergens.includes(key) === false) return false;
                }
            }
            return true;
        })
        .map((item, index) => {
            return (
                <MenuCard key={`item-${index}`} item={item} {...props} />
            );
        });
};

const renderMenuCategories = props => {
    const { data, culture, categoryType, offsetStyle, activeStep, termAndConditionsModalMenu } = props;
    return data.map((category, index) => {
        const menuItems =
            !category.menuItems || category.menuItems.length === 0
                ? null
                : renderMenuItems({ focusItem: props.focusItem, data: category.menuItems, activeStep: props.activeStep, categoryIndex: index, culture, categoryType });

        const menuCategories =
            !category.menuCategories || !category.menuCategories.length === 0
                ? null
                : renderMenuCategories({ focusItem: props.focusItem, data: category.menuCategories, activeStep: props.activeStep, termAndConditionsModalMenu, culture, categoryType });

        if ((!category.menuItems || category.menuItems.length === 0) && category.menuCategories === null) return null;


        

        return (
            <section aria-live="polite" ref={category.ref} className="menu-category" key={`category-${index}`} style={offsetStyle}>
                <div ref={category.titleRef} className="menu-section-title">
                    <div className="menu-section-intro">
                        <h3>{categoryPreferredName(category.name)}</h3>
                        {category.description && <p className="section-description">{category.description}</p>}
                    </div>
                </div>

                <ul className="menu-section-cards">
                    {menuItems}
                    {menuCategories}
                    {
                        category.name.toUpperCase() === 'CALZONE' && (
                            <li class="menu-section-info menu-section-vegan-info">
                                <div class="menu-section-info-inner">
                                    <div class="menu-section-info-content">
                                        <h4 class="font-swash-on">ALL YOUR FAVOURITES NOW AVAILABLE IN VEGAN</h4>
                                        <p class="sub-title">
                                            If you are cutting down on meat, veggie or just love the sound our vegan recipes, all your favourites can now be ordered in vegan -just click the dietary filter at the top to see our full vegan menu.
                                        </p>
                                    </div>
                                </div>
                            </li>
                        )
                    }

                </ul>                
                {index === props.data.length - 1 && <section className="menu-section menu-nutritional-info">
                    <div className="notification-container">
                        <div className="notification-wrapper">
                            <div className="notification-inner-wrapper">
                                <button className="legal-modal-link" onClick={termAndConditionsModalMenu}>Menu T&Cs</button>
                            </div>
                        </div>
                        <div className="notification-wrapper bg-yellow">
                            <div className="notification-inner-wrapper">
                                Adults need around 2000 kcal per day.
                            </div>
                        </div>
                    </div>
                </section>}

            </section>
        );
    });
};

const MenuPages = props => {
    const { data, selectedIndex, children, getPizzaCategoryLogoText, culture, digitalMenuOffsetHeight } = props;

    const rootCategories = data.menuCategories.filter(mc => mc.menuCategories.length !== 0) || [];
    const childrenArray = !!children && !children.length ? [children] : children;
    const rootCategoriesAndChildren = rootCategories.length + childrenArray.length;

    if (selectedIndex >= rootCategoriesAndChildren) return null;
    if (selectedIndex >= rootCategories.length) return childrenArray[selectedIndex - rootCategories.length];

    const selectedCategory = rootCategories[selectedIndex];

    const offsetStyle = {
        marginTop: -(digitalMenuOffsetHeight - 1),
        paddingTop: digitalMenuOffsetHeight + 1,
    };
    
    const menuItems =
        !selectedCategory.menuItems || selectedCategory.menuItems.length === 0
            ? null
            : renderMenuItems({ focusItem: props.focusItem, data: selectedCategory.menuItems, activeStep: props.activeStep, culture });
    const menuCategories =
        !selectedCategory.menuCategories || selectedCategory.menuCategories.length === 0
            ? null
            : renderMenuCategories({
                focusItem: props.focusItem,
                data: selectedCategory.menuCategories,
                activeStep: props.activeStep,
                termAndConditionsModalMenu: props.termAndConditionsModalMenu,
                culture,
                categoryType: selectedCategory.name,
                offsetStyle
            });

    return (
        <div className={`menu`}>
            <div className={`menu-intro ${selectedCategory.headerStyle.toLowerCase()}`}>
                <div className="d-flex is-row menu-intro-inner justify-content-between">
                    <span className="menu-decoration-left d-flex align-items-center justify-content-start">
                        <img className="menu-flourish" alt="null" src={burst}></img>
                        {/* <img className="hide-mobile menu-decoration-top" alt="null" src=""></img> */}
                        <img className="hide-mobile menu-decoration-bottom" alt="null" src={hand}></img>

                    </span>
                    <div className="menu-intro-block">
                        {!!selectedCategory.name && <h2>{categoryPreferredName(selectedCategory.name)}</h2>}
                        {selectedCategory.headerText && <p>{selectedCategory.headerText}</p>}
                        {selectedCategory.name.toLowerCase() == 'lunch' ? <p><a style={{ 'fontWeight': '900', 'textDecoration': 'underline' }} href='https://www.pizzaexpress.com/terms-and-conditions/lunch-menu' target='_blank'>Terms Apply</a></p> : ''}
                    </div>
                    <span className="menu-decoration-right d-flex align-items-center justify-content-end">
                        <img className="menu-flourish" alt="null" src={star}></img>
                        <img className="hide-mobile menu-decoration-top" alt="null" src={spinach}></img>
                        <img className="hide-mobile menu-decoration-bottom" alt="null" src={tomato}></img>
                    </span>
                </div>
            </div>

            <div className="menu-section">
                <div className="menu-category menu-category-container">
                    <div className="menu-section-cards">
                        {!menuCategories ? (
                            <section className="menu-category">
                                <div className="menu-section-title">
                                    <div className="menu-section-intro">
                                        <h3>{categoryPreferredName(selectedCategory.name)}</h3>
                                        <p>{selectedCategory.description}</p>
                                    </div>
                                </div>
                                {!menuItems ? (
                                    <div key={`item-none`} className={`no-item-description`}>
                                        <div className="item-title">
                                            <h4>
                                                <span className="name">No items found.</span>
                                            </h4>
                                        </div>
                                    </div>
                                ) : (
                                    <ul className="menu-section-cards">{menuItems}</ul>
                                )}
                            </section>
                        ) : (
                            ''
                        )}
                        {menuCategories}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default withAppState(MenuPages, {
    mobXProps: ({ digitalMenuOffsetHeight }) => ({
        digitalMenuOffsetHeight,
    }),
    mobXActions: ({
        termAndConditionsModalMenu
    }) => ({
        termAndConditionsModalMenu
    })
});
